import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type { ClientItem } from "owa-mail-store";
import type Item from "owa-service/lib/contract/Item";

const REPORT_CLASS_NAME_PREFIX = "report";
const NDR_CLASS_NAME = "report.ipm.note.ndr";
const DR_CLASS_NAME = "report.ipm.note.dr";
const STICKY_NOTE_CLASS_NAME_PREFIX = "ipm.stickynote";

export function isReportItem(item: Item): boolean {
    return !!item?.ItemClass && item.ItemClass.toLowerCase().indexOf(REPORT_CLASS_NAME_PREFIX) == 0;
}

export function isNDRItem(item: Item): boolean {
    return !!item?.ItemClass && item.ItemClass.toLowerCase().indexOf(NDR_CLASS_NAME) == 0;
}

export function isDRItem(item: Item): boolean {
    return !!item?.ItemClass && item.ItemClass.toLowerCase().indexOf(DR_CLASS_NAME) == 0;
}

export function isStickyNoteItem(item: Item | undefined): boolean {
    return (!!item?.ItemClass &&
        item.ItemClass.toLowerCase().indexOf(STICKY_NOTE_CLASS_NAME_PREFIX) == 0);
}

/**
 * Returns true when the given item is a sticky note item that lives in an Archive mailbox, and
 * the fp-archive-notes-folder flight is enabled. Mail item actions (reply, forward, summarize,
 * etc.) are not supported for these items, so this is the single source of truth callers should
 * use to decide whether to hide/disable those actions.
 *
 * The primary mailbox's own notes items are intentionally excluded even though they share the
 * same ItemClass, since mail item actions continue to be fully supported there.
 */
export function isArchiveNotesItem(item: ClientItem | undefined): boolean {
    return (isGlobalFeatureEnabled("fp-archive-notes-folder") &&
        item?.MailboxInfo?.type === "ArchiveMailbox" &&
        isStickyNoteItem(item));
}
